
define('text!templates/pages/schedule/timer.ejs',[],function () { return '<% if (timerLeft>0) { %>\n<div class="schedule-timer-arrow" style="left: <%= timerLeft %>px">\n</div>\n<% } %>';});

